// extracted by mini-css-extract-plugin
export default {"noClientsWrapper":"appLoadingIndicator_noClientsWrapper__DiG0A"};